export const getUrlParams = (name) => {
    let url = window.location.href;
    let p = url.split('?')[1];
    let params = new URLSearchParams(p);
    return params.get(name);
};
